
import React from 'react';
import { Solicitacao } from '@/types/solicitacao';
import { BookOpen } from 'lucide-react';

interface Props {
  requisicao: Solicitacao;
}

export const RequisicaoConhecimentoRelacionado = ({ requisicao }: Props) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-muted-foreground space-y-3">
      <BookOpen className="h-10 w-10" />
      <p className="font-medium">Conhecimento Relacionado</p>
      <p className="text-sm">Em breve</p>
    </div>
  );
};
